import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=197b2e1f&scoped=true"
import script from "./dashboard.ts?vue&type=script&lang=ts&external"
export * from "./dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=197b2e1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b2e1f",
  null
  
)

export default component.exports